import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/bookkeepings/zus-packages`;
export const modelName = 'zuspackage';

export default {
  ...apiCrud({ baseUri, modelName }),
};
